import React, { useEffect, useState } from "react";
import SectionWrapper from "./../../components/Shared/SectionWrapper";
import SideImage from "./../../assets/upload.png";
import { Button as AntButton, Form, Input, message, Spin } from "antd";
import { Label } from "../../styles";
import {
  CheckboxWrapper,
  FormWrapper,
  Spacer,
  TopicsContainer,
  UploadWrapper,
} from "./styles";
import Button from "./../../components/Shared/Button";
import authSelectors from "../../modules/auth/authSelectors";

import { useHistory } from "react-router-dom";
import appActions from "../../modules/app/appActions";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { PlusSquareFilled } from "@ant-design/icons";
import { randomIntFromInterval } from "../../Utils";
// @ts-ignore
import DraggableList from "react-draggable-list";
import cx from "classnames";
import { useIntercom } from "react-use-intercom";
import appSelectors from "../../modules/app/appSelectors";

const { TextArea } = Input;

const SectionContent = () => {
  return (
    <>
      <span
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: 22,
          fontWeight: "bold",
        }}
      >
        {/*<span style={{fontWeight: 'normal', marginRight: 5}}>{`Upload`}</span> your video or audio
        <Image className="image-left-margin" preview={false} src={Video}/>*/}
      </span>
    </>
  );
};

function matchYoutubeUrl(url) {
  const p =
    /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  if (url.match(p)) {
    return url.match(p)[1];
  }
  return false;
}

function youtubeParser(url) {
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[7].length === 11 ? match[7] : false;
}

const ACTION_BUTTON_TITLE = [
  "Create my blog post!",
  /* 'Confirm topic selection',*/
  "Confirm heading selection",
];

const Index = (props) => {
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [topics, setTopics] = useState([]);
  const [titles, setTitles] = useState([]);
  const [selectedTitles, setSelectedTitles] = useState({});
  const [transcript, setTranscript] = useState("");
  const [youtubeLink, setYoutubeLink] = useState("");
  const [transcriptTitle, setTranscriptTitle] = useState("");
  const [topic, setTopic] = useState("");
  const { videoTopic, videoId, videoTitle } = useSelector(
    appSelectors.selectSavedBlog
  );

  const [cookies, setCookie] = useCookies(["ytb-id"]);

  const history = useHistory();
  const dispatch = useDispatch();
  const currentUser = useSelector(authSelectors.selectCurrentUser);

  const { update } = useIntercom();

  useEffect(() => {
    //auth.signOut()
    if (!cookies["ytb-id"]) {
      setCookie("ytb-id", randomIntFromInterval(100000, 999999), { path: "/" });
    }
    update({ name: currentUser.displayName, email: currentUser.email });
  }, []);

  useEffect(() => {
    if (videoId) {
      setTopic(videoTopic);
      setTranscriptTitle(videoTitle);
    }
    if (props.match.path === "/upload2") {
      setStep(1);
      getTranscript(videoId, videoTitle);
    }
  }, [props.match.path, videoId, videoTitle, videoTopic]);

  const onFinish = (values) => {};

  const onCreate = async () => {
    if (!youtubeLink) return;
    if (youtubeLink && !matchYoutubeUrl(youtubeLink)) {
      message.error(`Only youtube video urls are supported.`);
      return;
    }
    if (!transcriptTitle) {
      message.error(`Please enter transcript title`);
      return;
    }
    setLoading(true);
    const videoId = youtubeParser(youtubeLink);
    await dispatch(appActions.initBlog(videoId, transcriptTitle, topic));
    history.push("/upload2");
  };

  useEffect(() => {
console.log(transcript);

  },[transcript])

  const getTranscript = (videoId, videoTitle) => {
    setLoading(true);
    const userId = cookies["ytb-id"];
    appActions.getTranscript(videoId, userId).then(
      (transcript) => {
        setTranscript(transcript);

        appActions.getTopics(videoTitle, transcript, userId).then(
          (topics) => {
            setLoading(false);
            setTopics(topics.map((topic, index) => ({ topic, key: index })));
            setStep(1);
          },
          (error) => {
            console.log(error);
            alert(error);
            setLoading(false);
          }
        );
      },
      (error) => {
        console.log(error);
        alert(error);
        setLoading(false);
      }
    );
    //const key = Math.random().toString(36).substring(7)
    // setLoading(true);
  };
  const getParagraphs = () => {
    console.log('video', videoId)
    setLoading(true);
    const userId = cookies["ytb-id"];
    const _topics = topics.filter((topic) => topic.selected !== false);
    dispatch(
      appActions.getParagraphs(
        transcriptTitle,
        _topics,
        userId,
        youtubeLink,
        topic,
        videoId
      )
    ).then(
      (id) => {
        setLoading(false);
        history.push(`/processing/${id}`);
      },
      (error) => {
        console.log(error);
        alert(error);
        setLoading(false);
      }
    );
  };
  const renderTopic = (props) => {
    const { item, itemSelected, dragHandleProps } = props;
    const scale = itemSelected * 0.01 + 1;
    const dragged = itemSelected !== 0;
    return (
      <div
        className={cx("item", { dragged })}
        style={{
          transform: `scale(${scale})`,
        }}
      >
        <div className="dragHandle" {...dragHandleProps} />
        <TopicsContainer>
          <CheckboxWrapper
            defaultChecked={item.selected !== false}
            onChange={(e) => {
              let index = topics.findIndex((_item) => _item.key == item.key);
              topics[index].selected = e.target.checked;
              setTopics(topics);
            }}
          />
          <TextArea
            onChange={(e) => {
              let index = topics.findIndex((_item) => _item.key == item.key);
              topics[index].topic = e.target.value;
              setTopics(topics);
            }}
            defaultValue={item.topic}
            autoSize={true}
            maxLength={150}
            className={"topic-input"}
            placeholder="Topic title"
          />
        </TopicsContainer>
      </div>
    );
  };
  if (!currentUser || !currentUser.displayName) return <div></div>;
  return (
    <>
      <UploadWrapper>
        <SectionWrapper
          bgColor="secoundary"
          image={SideImage}
          SectionContent={SectionContent}
        >
          <FormWrapper>
            <Form
              name="normal_upload"
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
            >
              <Carousel
                showArrows={false}
                showIndicators={false}
                showStatus={false}
                selectedItem={step}
              >
                <div style={{ textAlign: "left" }}>
                  <Label>Insert Youtube link</Label>
                  <Form.Item
                    rules={[
                      { required: true, message: "Youtube link is required" },
                    ]}
                    name="link"
                  >
                    <Input
                      className="input"
                      onChange={(e) => setYoutubeLink(e.target.value)}
                    />
                  </Form.Item>
                  <Spacer>
                    <p>and</p>
                  </Spacer>
                  <Label>
                    Insert Youtube title (or what you want your blog to be
                    about!)
                  </Label>
                  <Form.Item
                    rules={[{ required: true, message: "Title is required" }]}
                    name="title"
                  >
                    <Input
                      placeholder={
                        "e.g The 9 Best Ecom Niches to Utilise in 2022"
                      }
                      className="input"
                      onChange={({ target }) =>
                        setTranscriptTitle(target.value)
                      }
                    />
                  </Form.Item>
                  <Spacer>
                    <p>and</p>
                  </Spacer>
                  <Label>Insert Keyword/Topic</Label>
                  <Form.Item
                    rules={[
                      { required: true, message: "Keyword/Topic is required" },
                    ]}
                    name="topic"
                  >
                    <Input
                      placeholder={"e.g Ecommerce niches"}
                      className="input"
                      onChange={({ target }) => setTopic(target.value)}
                    />
                  </Form.Item>
                </div>
                <div style={{ textAlign: "left" }}>
                  <>
                    {" "}
                    <DraggableList
                      itemKey="key"
                      template={renderTopic}
                      list={topics}
                      onMoveEnd={(newList) => setTopics(newList)}
                      container={() => document.body}
                    />
                    <AntButton
                      type="text"
                      style={{
                        color: "#575757",
                        fontSize: 12,
                        fontWeight: "bold",
                      }}
                      onClick={(e) => {
                        const _topics = [...topics];
                        _topics.push({ topic: "", key: topics.length });
                        setTopics(_topics);
                      }}
                      icon={
                        <PlusSquareFilled
                          style={{
                            color: "#4A60F4",
                            fontSize: 20,
                            marginLeft: 13,
                            marginRight: 7,
                          }}
                        />
                      }
                    >
                      Add Heading
                    </AntButton>
                  </>
                  {loading && (
                    <div style={{ textAlign: "center", marginTop: 150 }}>
                      <Spin />
                    </div>
                  )}
                </div>
                <div>
                  {titles.map((title, index) => (
                    <TopicsContainer>
                      <CheckboxWrapper
                        checked={selectedTitles[title] !== false}
                        onChange={(e) => {
                          const selections = { ...selectedTitles };
                          selections[title] = e.target.checked;
                          setSelectedTitles(selections);
                        }}
                      />
                      <TextArea
                        onChange={(e) => {
                          const _titles = [...titles];
                          _titles[index] = e.target.value;
                          setTitles(_titles);
                        }}
                        autoSize={true}
                        maxLength={150}
                        className={"topic-input"}
                        placeholder="Topic title"
                        value={title}
                      />
                    </TopicsContainer>
                  ))}
                </div>
              </Carousel>

              <Button
                className="upload__submit--btn"
                handleClick={
                  step === 0
                    ? onCreate
                    : step === 1
                    ? getParagraphs
                    : getParagraphs
                }
                veriant="primary"
                size="medium"
                block
                loading={loading}
                type="submit"
              >
                {ACTION_BUTTON_TITLE[step]}
              </Button>
              <div style={{color:'red', fontSize: 10, fontWeight:'bold', marginTop: 10, marginBottom: 10}}>
                <span>YOUTUBE VIDEOS MUST HAVE A ‘TRANSCRIPT’ AND ‘CHAPTERS’ INCLUDED ON THE VIDEO.<br/></span>
                <span>Example video: <a style={{color:'red'}} target="_blank" href="https://www.youtube.com/watch?v=rpwD50v0Ubo">https://www.youtube.com/watch?v=rpwD50v0Ubo</a>
                </span>
              </div>
            </Form>
          </FormWrapper>
        </SectionWrapper>
      </UploadWrapper>
    </>
  );
};

export default Index;
